import { render, staticRenderFns } from "./ProductsUploaderModal.vue?vue&type=template&id=5d783e96&"
import script from "./ProductsUploaderModal.vue?vue&type=script&lang=js&"
export * from "./ProductsUploaderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports